<template>
  <div id="top"
    class="flex-col flex gap-4 py-10 px-4 sm:px-6 lg:px-8 max-w-5xl shadow-lg rounded-lg bg-white border border-gray-200">
    <div class="flex justify-center cursor-default">
      <h1 class="text-2xl font-bold leading-10 text-center my-6 tracking-tight text-gray-900">
        Frequently Asked Questions &amp; Contact Us
      </h1>
    </div>
    <frequently-asked-questions></frequently-asked-questions>
  </div>
</template>

<script>
import FrequentlyAskedQuestions from "./FrequentlyAskeduestions.vue";

export default {
  name: 'FaqPage',

  components: {
    FrequentlyAskedQuestions
  }
}
</script>
